var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('v-tabs',_vm._l((_vm.tabs),function(tab,index){return _c('v-tab',{key:index,attrs:{"to":tab.to}},[_vm._v(_vm._s(tab.text))])}),1),_vm._v(" "),_c('div',{staticClass:"pa-3"},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48affd4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/template/AssetWise/Management/index.vue
// module id = null
// module chunks = 